var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-qrcode d-none d-print-block"},[_c('vue-qrcode',{attrs:{"value":_vm.currentUrl,"margin":0,"scale":2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }